module.exports = __webpack_public_path__ + "img/top_left.22668850.png";